import * as React from 'react';
import { Button } from '../components/Button';
import { Icon } from '../components/Icon';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Tooltip } from '../components/Tooltip';

interface ReadonlyFieldProps {
	label: string;
	text: string;
	copy?: boolean;
	note?: string;
}

interface ReadonlyFieldState {
	copied: boolean;
}

export default class ReadonlyField extends React.Component<ReadonlyFieldProps, ReadonlyFieldState> {
	constructor(props) {
		super(props);
		this.state = {
			copied: false,
		};
	}

	render() {
		return (
			<div className="em-c-field em-c-search-form em-is-disabled">
				<label className="em-c-field__label">{this.props.label}</label>
				<div className="em-c-field__body">
					<div className="em-c-search__body">
						<input className="em-c-input" disabled value={this.props.text} />
						{this.props.copy && (
							<Tooltip content={this.state.copied ? 'Copied!' : 'Copy to clipboard'}>
								<CopyToClipboard
									text={this.props.text}
									onCopy={() => {
										this.setState({ copied: true });
									}}
								>
									<Button variant="secondary" onBlur={() => this.setState({ copied: false })}>
										<Icon icon="copy" size="small" />
									</Button>
								</CopyToClipboard>
							</Tooltip>
						)}
					</div>

					{this.props.note && (
						<>
							<div className="em-c-field__note">{this.props.note}</div>
						</>
					)}
				</div>
			</div>
		);
	}
}